import React from 'react';
import { InputSection, Label, Input } from './style';

const LoginPasswordInputSection = ({ password, setPassword }) => {
    return (
        <InputSection>
            <Label htmlFor="password">비밀번호</Label>
            <Input
                type="password"
                id="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="비밀번호를 입력하세요"
            />
        </InputSection>
    );
};

export default LoginPasswordInputSection;
